var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.isOpenUpdateTicketAppDialog,
            width: "1720px",
            "before-close": _vm.closeDialog,
            "close-on-click-modal": false,
            top: "3vh",
            title: "Cập nhật phiếu bé ngoan",
            border: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isOpenUpdateTicketAppDialog = $event
            },
            open: _vm.handleOpen,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "updateTicketAppRequest",
              attrs: {
                "label-width": "140px",
                model: _vm.updateTicketAppRequest,
                "label-position": "left",
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 100 } },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c(
                      "div",
                      { staticClass: "grid-content" },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "Tên phiếu bé ngoan",
                              prop: "nameTicket",
                              "label-width": "170px",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "Nhập tên" },
                              model: {
                                value: _vm.updateTicketAppRequest.nameTicket,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.updateTicketAppRequest,
                                    "nameTicket",
                                    $$v
                                  )
                                },
                                expression: "updateTicketAppRequest.nameTicket",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c(
                      "div",
                      { staticClass: "grid-content" },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "Mô tả", "label-width": "80px" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "Nhập mô tả" },
                              model: {
                                value:
                                  _vm.updateTicketAppRequest.descriptionTicket,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.updateTicketAppRequest,
                                    "descriptionTicket",
                                    $$v
                                  )
                                },
                                expression:
                                  "updateTicketAppRequest.descriptionTicket",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Phiên bản",
                            prop: "version",
                            required: "",
                            "label-width": "170px",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.updateTicketAppRequest.version)),
                          ]),
                          _c("el-input-number", {
                            staticStyle: { "margin-left": "10px" },
                            attrs: { min: 0 },
                            model: {
                              value: _vm.version,
                              callback: function ($$v) {
                                _vm.version = $$v
                              },
                              expression: "version",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 9 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "Màn hình", "label-width": "170px" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "228px" },
                              attrs: { placeholder: "Chọn màn hình" },
                              on: { change: _vm.handleChangeDisplayTicket },
                              model: {
                                value: _vm.displayTicket,
                                callback: function ($$v) {
                                  _vm.displayTicket = $$v
                                },
                                expression: "displayTicket",
                              },
                            },
                            _vm._l(_vm.listDisplayTicket, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                staticStyle: { width: "200px" },
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "dataTarget",
                        label: "Chọn trường",
                        "label-width": "170px",
                      },
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 3 } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "170px" },
                              attrs: {
                                placeholder: "Trạng thái kích hoạt",
                                clearable: "",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.searchHeaderMethod()
                                },
                              },
                              model: {
                                value: _vm.dataSearch.active,
                                callback: function ($$v) {
                                  _vm.$set(_vm.dataSearch, "active", $$v)
                                },
                                expression: "dataSearch.active",
                              },
                            },
                            _vm._l(_vm.statusAccountList, function (item) {
                              return _c("el-option", {
                                key: item.key,
                                attrs: { value: item.key, label: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "margin-left": "35px" },
                          attrs: { span: 3 },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "button-left-class",
                              staticStyle: { width: "160px" },
                              attrs: {
                                placeholder: "Trạng thái xóa",
                                clearable: "",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.searchHeaderMethod()
                                },
                              },
                              model: {
                                value: _vm.dataSearch.deleteStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.dataSearch, "deleteStatus", $$v)
                                },
                                expression: "dataSearch.deleteStatus",
                              },
                            },
                            _vm._l(_vm.deleteList, function (item) {
                              return _c("el-option", {
                                key: item.key,
                                attrs: { value: item.key, label: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "margin-left": "25px" },
                          attrs: { span: 4 },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "250px" },
                            attrs: {
                              placeholder: "Nhập tên trường",
                              clearable: "",
                            },
                            on: {
                              clear: function ($event) {
                                return _vm.searchHeaderMethod()
                              },
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.searchHeaderMethod()
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "append",
                                fn: function () {
                                  return [
                                    _c("el-button", {
                                      attrs: { icon: "el-icon-search" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.searchHeaderMethod()
                                        },
                                      },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.dataSearch.nameSchool,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataSearch, "nameSchool", $$v)
                              },
                              expression: "dataSearch.nameSchool",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { staticStyle: { "margin-bottom": "20px" } },
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: { "margin-left": "50px" },
                      attrs: { span: 11 },
                    },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "custom-background-1",
                          attrs: { header: "Danh sách trường chưa áp dụng" },
                        },
                        [
                          _c("el-transfer", {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.loadingDataTransfer,
                                expression: "loadingDataTransfer",
                              },
                            ],
                            attrs: {
                              "element-loading-text": _vm.$tableLoading,
                              titles: [
                                "Trường chưa áp dụng",
                                "Trường được chọn",
                              ],
                              "button-texts": ["", ""],
                              data: _vm.dataSource,
                            },
                            model: {
                              value: _vm.dataTarget,
                              callback: function ($$v) {
                                _vm.dataTarget = $$v
                              },
                              expression: "dataTarget",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    {
                      staticStyle: { "margin-left": "30px" },
                      attrs: { span: 11 },
                    },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "custom-background-2",
                          attrs: { header: "Danh sách trường đã áp dụng" },
                        },
                        [
                          _c("el-transfer", {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.loadingDataTransfer,
                                expression: "loadingDataTransfer",
                              },
                            ],
                            attrs: {
                              "element-loading-text": _vm.$tableLoading,
                              titles: [
                                "Trường đã áp dụng",
                                "Trường hủy áp dụng",
                              ],
                              "button-texts": ["", ""],
                              data: _vm.dataSourceApply,
                            },
                            model: {
                              value: _vm.dataTargetCancelApply,
                              callback: function ($$v) {
                                _vm.dataTargetCancelApply = $$v
                              },
                              expression: "dataTargetCancelApply",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c("el-row", [
                    _c("span", [
                      _c("b", { staticStyle: { "font-size": "17px" } }, [
                        _vm._v("Thêm ảnh"),
                      ]),
                    ]),
                  ]),
                  _c("hr"),
                  [
                    _c(
                      "el-upload",
                      {
                        ref: "uploadTicket",
                        staticStyle: { "margin-left": "35px", clear: "both" },
                        attrs: {
                          action: "#",
                          "list-type": "picture-card",
                          "auto-upload": false,
                          "file-list": _vm.fileListTicket,
                          "on-change": _vm.handleChangePictureTicket,
                          "on-remove": _vm.handleRemoveTicket,
                          "before-remove": _vm.beforeRemove,
                          "on-preview": _vm.handlePictureCardPreviewTicket,
                          multiple: "",
                        },
                      },
                      [
                        _c(
                          "i",
                          {
                            staticClass: "el-icon-plus",
                            staticStyle: {
                              "font-style": "normal",
                              "white-space": "nowrap",
                            },
                            attrs: { slot: "default" },
                            slot: "default",
                          },
                          [_vm._v("Thêm Ảnh")]
                        ),
                      ]
                    ),
                    _c(
                      "el-dialog",
                      {
                        attrs: {
                          width: "50%",
                          visible: _vm.dialogVisibleTicket,
                        },
                        on: {
                          "update:visible": function ($event) {
                            _vm.dialogVisibleTicket = $event
                          },
                        },
                      },
                      [
                        _c("img", {
                          attrs: {
                            width: "100%",
                            src: _vm.dialogImageUrlTicket,
                            alt: "",
                          },
                        }),
                      ]
                    ),
                  ],
                  _c("el-row", [
                    _c("span", [
                      _c("b", { staticStyle: { "font-size": "17px" } }, [
                        _vm._v("Danh sách: " + _vm._s(_vm.titleTicket)),
                      ]),
                    ]),
                  ]),
                  _c("hr"),
                  _c(
                    "el-row",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-wrap": "wrap",
                        width: "100%",
                        "margin-top": "10px",
                        border: "1px solid rgb(96 99 102 / 19%)",
                        "max-height": "600px",
                        "padding-left": "50px",
                        height: "305px",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            width: "100%",
                            "overflow-x": "hidden",
                            "max-height": "600px",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                transition: "all 0.5s linear",
                              },
                              style: {
                                transform: `translateX(-${
                                  _vm.currentSlideIndex *
                                  (100 /
                                    (this.listTicketUpdate.length /
                                      this.itemsToShow))
                                }%)`,
                              },
                            },
                            _vm._l(_vm.listTicketUpdate, function (item) {
                              return _c(
                                "div",
                                {
                                  key: item.id,
                                  staticStyle: {
                                    flex: "0 0 223px",
                                    margin: "30px",
                                    width: "223px",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "inline-block-div" },
                                    [
                                      _c("el-image", {
                                        staticStyle: {
                                          width: "200px",
                                          height: "200px",
                                        },
                                        attrs: { src: item.urlPicture },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleShowImageDialog(
                                              item.urlPicture
                                            )
                                          },
                                        },
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "el-upload-list__item-actions",
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              staticClass:
                                                "el-upload-list__item-preview",
                                              staticStyle: {
                                                float: "left",
                                                height: "40px",
                                                width: "200px",
                                              },
                                              attrs: { type: "success" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deletePicture(
                                                    item.id
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-delete-solid",
                                                staticStyle: { color: "white" },
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      ),
                      _vm.listTicketUpdate.length > 0
                        ? _c("div", { staticClass: "container_btn_nav" }, [
                            _c(
                              "span",
                              {
                                staticClass: "btn_nav btn-next",
                                staticStyle: {
                                  right: "-18px",
                                  top: "50%",
                                  position: "absolute",
                                },
                                style: {
                                  cursor:
                                    _vm.currentSlideIndex === _vm.maxIndex
                                      ? "not-allowed"
                                      : "pointer",
                                },
                                on: { click: _vm.nextSlide },
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "lucide lucide-chevron-right",
                                    attrs: {
                                      xmlns: "http://www.w3.org/2000/svg",
                                      width: "24",
                                      height: "24",
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      stroke: "currentColor",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: { d: "m9 18 6-6-6-6" },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "btn_nav btn-prev",
                                staticStyle: {
                                  left: "-18px",
                                  top: "50%",
                                  position: "absolute",
                                },
                                style: {
                                  cursor:
                                    _vm.currentSlideIndex === 0
                                      ? "not-allowed"
                                      : "pointer",
                                },
                                on: { click: _vm.prevSlide },
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "lucide lucide-chevron-left",
                                    attrs: {
                                      xmlns: "http://www.w3.org/2000/svg",
                                      width: "24",
                                      height: "24",
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      stroke: "currentColor",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: { d: "m15 18-6-6 6-6" },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ],
                2
              ),
              _c(
                "div",
                { staticClass: "tab-infor-button" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "success",
                        size: "medium",
                        loading: _vm.loadingButton,
                        mini: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("updateTicketAppRequest")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-circle-check" }),
                      _c("span", [_vm._v("Lưu")]),
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger", size: "medium" },
                      on: {
                        click: function ($event) {
                          return _vm.closeDialog()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-circle-close" }),
                      _c("span", [_vm._v("Đóng")]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { width: "30%", visible: _vm.dialogVisibleTemplateDefault },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisibleTemplateDefault = $event
            },
          },
        },
        [
          _c("img", {
            attrs: { width: "100%", src: _vm.urlTemplateDefault, alt: "" },
          }),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            width: "30%",
            visible: _vm.currentImageDialog.isVisibleDialog,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.currentImageDialog, "isVisibleDialog", $event)
            },
          },
        },
        [
          _c("img", {
            attrs: {
              width: "100%",
              src: _vm.currentImageDialog.currentImageUrl,
              alt: "",
            },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }